// src/pages/Home/Components/CreativleyProduct.jsx
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProductCard from '../../../components/ui/ProductCard';
import ErrorBoundary from '../../../components/ErrorBoundary';

const CreativleyProduct = () => {
  const { products, loading } = useSelector((state) => state.listProduct) || { products: [], loading: false };

  const topCategories = useMemo(() => {
    if (!products || products.length === 0) return [];

    const categoryMap = {};
    products.forEach((product) => {
      const categoryName = product.category_name || product.category?.name;
      if (categoryName) {
        if (!categoryMap[categoryName]) {
          categoryMap[categoryName] = [];
        }
        categoryMap[categoryName].push(product);
      }
    });

    const sortedCategories = Object.entries(categoryMap)
      .map(([categoryName, productList]) => ({
        name: categoryName,
        count: productList.length,
        products: productList,
      }))
      .sort((a, b) => b.count - a.count);

    return sortedCategories.slice(0, 4);
  }, [products]);

  const [activeTab, setActiveTab] = useState(topCategories[0]?.name || '');

  const filteredProducts = useMemo(() => {
    if (!topCategories.length) return [];
    const category = topCategories.find((cat) => cat.name === activeTab);
    return category ? category.products : [];
  }, [topCategories, activeTab]);

  if (loading) {
    return (
      <div className="max-w-[1280px] w-[95%] m-auto mt-10">
        <div className="h-[100px] rounded-2xl flex items-center justify-center" style={{ backgroundColor: '#9EAD8C' }}>
          <p className="text-white text-sm">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  if (topCategories.length === 0) {
    return (
      <div className="max-w-[1280px] w-[95%] m-auto mt-20">
        <div className="h-[100px] rounded-2xl flex items-center justify-center" style={{ backgroundColor: '#9EAD8C' }}>
          <p className="text-white text-sm">هیچ دسته‌بندی با محصولی یافت نشد</p>
        </div>
      </div>
    );
  }

  if (!topCategories.some((cat) => cat.name === activeTab)) {
    setActiveTab(topCategories[0].name);
  }

  return (
    <div className="max-w-[1280px] w-[95%] m-auto pt-10 pb-10">

      <div className="rounded-t-2xl py-4 px-4 h-[130px]" style={{ backgroundColor: '#9EAD8C' }}>
        <h2 className="text-white text-sm md:text-base font-bold text-center mb-3">
          محصولات خلاقانه اریس گالری
        </h2>

        <div className="flex justify-center items-center text-xs sm:text-sm gap-4 overflow-x-auto px-2">
          {topCategories.map((category) => (
            <button
              key={category.name}
              onClick={() => setActiveTab(category.name)}
              className={`cursor-pointer whitespace-nowrap transition-all duration-200 pb-1 ${
                activeTab === category.name
                  ? 'text-black font-bold border-b-2'
                  : 'text-white/60 hover:text-white/80'
              }`}
              style={{ borderColor: activeTab === category.name ? '#000000' : 'transparent' }}
            >
              {category.name}
            </button>
          ))}
        </div>
      </div>

      <div className="-mt-5">
        <ErrorBoundary fallbackMessage="مشکلی در نمایش این دسته‌بندی پیش آمد.">
          {filteredProducts.length > 0 ? (
            <Swiper
              key={activeTab}
              dir="rtl"
              modules={[Navigation, Pagination]}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              className="w-full !pb-12"
              spaceBetween={16}
              slidesPerView={5}
              breakpoints={{
                0: { spaceBetween: 10, slidesPerView: 1.2 },
                380: { spaceBetween: 10, slidesPerView: 1.5 },
                480: { spaceBetween: 10, slidesPerView: 2 },
                640: { slidesPerView: 2.5 },
                768: { slidesPerView: 3.2 },
                1024: { slidesPerView: 4.2 },
                1280: { slidesPerView: 5 },
              }}
            >
              {filteredProducts.map((product) => (
                <SwiperSlide key={product._id} className="!h-auto">
                  <div className="px-1 py-2">
                    <ProductCard {...product} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="text-center py-8 text-sm" style={{ color: '#79716B' }}>
              محصولی برای این دسته‌بندی وجود ندارد.
            </div>
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default CreativleyProduct;